// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.company.RentalManagerUserManagementCompanyWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser,
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties,
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats,
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles,
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path,
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles,
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path,
  RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  RentalManagerUserCompanyStatsDto,
  RentalManagerUserProfilesDto,
  RentalManagerUserProfileUpdateRequestDto,
  RentalManagerUserPropertyDetailsListDto,
  UserManagementCompanyPropertyDetailsListDto,
  Zuid,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetCompanyListingsForUserParams {
  zuid: Zuid;
}
interface GetPendingProfileParams {
  email: string;
}
interface GetPendingUserPropertiesParams {
  email: string;
}
interface GetUserProfilesParams {
  /**
   * @deprecated
   */
  userBrand?: string;
  userToken?: string;
}

export type RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Options = UseQueryOptions<
  UserManagementCompanyPropertyDetailsListDto,
  unknown,
  UserManagementCompanyPropertyDetailsListDto,
  readonly [string, GetCompanyListingsForUserParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey = (
  getParams: GetCompanyListingsForUserParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_queryOptions = (
  getParams: GetCompanyListingsForUserParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser = (
  getParams: GetCompanyListingsForUserParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string, GetPendingProfileParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey = (getParams: GetPendingProfileParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_queryOptions = (
  getParams: GetPendingProfileParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get an invited user's pending profile
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getPendingProfile = (
  getParams: GetPendingProfileParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getPendingProfile.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Options = UseQueryOptions<
  RentalManagerUserPropertyDetailsListDto,
  unknown,
  RentalManagerUserPropertyDetailsListDto,
  readonly [string, GetPendingUserPropertiesParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey = (
  getParams: GetPendingUserPropertiesParams,
) => [RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_queryOptions = (
  getParams: GetPendingUserPropertiesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a pending user's properties
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties = (
  getParams: GetPendingUserPropertiesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Options = UseQueryOptions<
  RentalManagerUserCompanyStatsDto,
  unknown,
  RentalManagerUserCompanyStatsDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats(httpClient),
  }) as const satisfies QueryOptions;

export const useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey = () =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey(),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the current user's company users
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_GetKey;

export type RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Options = UseQueryOptions<
  RentalManagerUserProfilesDto,
  unknown,
  RentalManagerUserProfilesDto,
  readonly [string, GetUserProfilesParams]
>;

const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey = (getParams: GetUserProfilesParams) =>
  [RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path, getParams] as const;

export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_queryOptions = (
  getParams: GetUserProfilesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey(getParams),
    queryFn: () => RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user profiles including feature access and properties permissions
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_getUserProfiles = (
  getParams: GetUserProfilesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserManagementCompanyWebApiHandler_getUserProfiles.getKey =
  RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_GetKey;

export interface RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args {
  postData: RentalManagerUserProfileUpdateRequestDto;
}

export type RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args
>;

/**
 * Update existing user settings
 */
export const useRentalManagerUserManagementCompanyWebApiHandler_updateUserSettings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Args) =>
      RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings(args.postData, httpClient),
  });
};
